import React from 'react';
import { Link } from 'gatsby';

export interface LinkToProps {
  to: string;
  onClick?: any;
  className?: string;
  disableActiveClassName?: boolean;
  state?: any;
  id?: string;
  label?: string;
  title?: string;
  partiallyActive?: boolean;
  target?: string;
}

export const LinkTo = ({
  to,
  children,
  label,
  onClick,
  disableActiveClassName,
  state,
  title,
  id,
  partiallyActive,
  target,
  ...rest
}: React.PropsWithChildren<LinkToProps>) => {
  const domain = process.env.GATSBY_SITE_URL || process.env.GATSBY_FRONTEND_URL;

  let link = to;
  let isExternal = to?.trim().startsWith('http');
  const isAnchor = to?.trim().startsWith('#');
  const isMail = to?.trim().startsWith('mailto');
  const isTel = to?.trim().startsWith('tel');
  const isFile = /\.[0-9a-z]+$/i.test(to);

  if (to && isExternal && domain && link?.includes(domain)) {
    [, link] = to.split(domain);
    isExternal = false;
  }

  const linkTitle = `${title || label || ''}${
    (target && target === '_blank') || isExternal
      ? `${title || label ? '' : 'Link'} - opens in a new tab`
      : ''
  }`;

  return isExternal || isAnchor || isMail || isTel || isFile || !to ? (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={link}
      target={target || (isExternal ? '_blank' : '')}
      rel={isExternal ? 'noopener' : ''}
      onClick={onClick}
      id={id}
      title={linkTitle}
      {...rest}
    >
      {label || children}
    </a>
  ) : (
    <Link
      to={link}
      id={id}
      activeClassName={disableActiveClassName ? undefined : 'is-active'}
      onClick={onClick}
      title={linkTitle}
      state={state}
      partiallyActive={partiallyActive}
      {...rest}
    >
      {label || children}
    </Link>
  );
};

export default LinkTo;
